import React, { useState } from "react";
import { Play, Plus, X } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const videos = [{
  id: 1,
  title: "RED BULL AIRRACE | MOTION GRAPHICS",
  category: "TV-SHOW",
  duration: "02:45",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/REd-Bull-Icon_Fanava_HP_MT_01-scaled.png?v=rf1wf4kzw68",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/red_bull_airrace_2008-720p.mp4",
  progress: 100
}, {
  id: 2,
  title: "DAMARIS | EDIT",
  category: "Commercial",
  duration: "01:15",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Damaris_icon_Fanava_HP_MT_01-scaled.jpg?v=hyygry9xhu",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Damaris_MT.mp4",
  progress: 100
}, {
  id: 3,
  title: "DAVID GANDI FASHION | EDIT",
  category: "FASHION VIDEO",
  duration: "04:20",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/David_Gandy_Fashion_icon_Fanava_HP_MT_01-scaled.jpg?v=g66y5npsfj6",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/David_Gandi_Fashion_MT.mp4",
  progress: 100
}, {
  id: 4,
  title: "HAEGEN DAZZ | EDIT",
  category: "ADVERTISEMENT",
  duration: "12:00",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Haegen_Dazz_icon_Fanava_HP_MT_01-scaled.jpg?v=m6db2jend6",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Haagen-Dasz-Girl-Time-35.mov",
  progress: 100
}, {
  id: 5,
  title: "EMPORIO ARMANIE | EDIT&GRADE",
  category: "Documentary",
  duration: "08:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Emporio_Armani_icon_Fanava_HP_MT_02-scaled.jpg?v=qrk89bewrco",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Emporer_Armani_SM_MT.mp4",
  progress: 100
}, {
  id: 6,
  title: "HONDA | COLOR",
  category: "Feature Film",
  duration: "05:10",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Honda_icon_Fanava_HP_MT_01-scaled.jpg?v=vfq891y0cw",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Honda_MT_03.mp4",
  progress: 100
}, {
  id: 7,
  title: "RAMPAGE | PREVIS&VFX",
  category: "Commercial",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Rampage_quer_02.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Rampage_Trailer.mp4",
  progress: 100
}, {
  id: 8,
  title: "BECKS | EDIT",
  category: "COMMERCIAL",
  duration: "03:55",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Becks_icon_Fanava_HP_MT_01-scaled.jpg?v=kafi1ig7av9",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/becks60.mov",
  progress: 100
}, {
  id: 9,
  title: "NYDENION | VFX",
  category: "FEATURE FILM",
  duration: "01:00",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/nydenion-2010-film-science-fiction-2.jpg?v=936gb3d0px",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Nydenion_Trailer.mp4",
  progress: 100
}, {
  id: 10,
  title: "EBENHOLZ | COLOR & MOTIONGRAPHICS",
  category: "COMMERCIAL",
  duration: "01:00",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Ebenholz-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/ebenholz_english-720p.mp4",
  progress: 100
}, {
  id: 11,
  title: "LEICA | CONCEPT & 3D ANIMATION",
  category: "COMMERCIAL",
  duration: "03:55",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/leica_02-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/leica_monochrom-720p.mp4",
  progress: 100
}, {
  id: 12,
  title: "NIKE | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Nike_02-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Nike_Dark_MT.mp4",
  progress: 100
}, {
  id: 13,
  title: "CHAPPY | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Chappy_Director_MT_01.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/CHAPPY_MT.mp4",
  progress: 100
}, {
  id: 14,
  title: "HENNESSY | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "03:55",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Hennessey_MT_02-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Hennessy_MT.mp4",
  progress: 100
}, {
  id: 15,
  title: "ROSWELL | FX-EDIT & 3D/MOTIONGRAPHIS",
  category: "DOCUMENTARY",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Histrory_channel-Roswell_MT_01-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Historie_Roswell_MT.mp4",
  progress: 100
}, {
  id: 16,
  title: "KFC | EDIT",
  category: "COMMERCIAL",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/KFC_MT-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/KFC_MT.mp4",
  progress: 100
}, {
  id: 17,
  title: "GUDE | CONCEPT & 3DANIMATION/EDIT",
  category: "COMMERCIAL",
  duration: "03:55",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/GUDE_MT-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/GUDE_MT.mp4",
  progress: 100
}, {
  id: 18,
  title: "POJOLA | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Pohjola_MTJPG-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Pohjola_MT.mp4",
  progress: 100
}, {
  id: 19,
  title: "TV-SHOW TRAILER | CONCEPT & GRAPHICS",
  category: "TV",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/TV_Trailer_MT_03-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/tv_trailer-lower_thirds-720p-1.mp4",
  progress: 100
}, {
  id: 20,
  title: "REISS | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "03:55",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Reiss_MT_01-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/REISS_MT.mp4",
  progress: 100
}, {
  id: 21,
  title: "VOGUE-INDIA | EDIT & COLOR",
  category: "COMMERCIAL",
  duration: "00:30",
  image: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/VOGUE_MT_02-scaled.jpg",
  src: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/VOGUE_MT-1.mp4",
  progress: 100
}];
type VideoItem = (typeof videos)[number];
const PAGE_SIZE = 9;
export default function TheVisualFeed() {
  const [displayedVideos, setDisplayedVideos] = useState<VideoItem[]>(videos.slice(0, PAGE_SIZE));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<VideoItem | null>(null);
  const isHost = false;
  const hasMore = displayedVideos.length < videos.length;
  const handleShowLess = () => {
    setDisplayedVideos(videos.slice(0, PAGE_SIZE));
    document.getElementById("selected-works")?.scrollIntoView({
      behavior: "smooth"
    });
  };
  const handleLoadMore = () => {
    const nextBatch = videos.slice(displayedVideos.length, displayedVideos.length + PAGE_SIZE);
    setDisplayedVideos(prev => [...prev, ...nextBatch]);
  };
  const handleViewAll = () => {
    setDisplayedVideos(videos);
  };
  return <section data-section-id="47690" id="selected-works" className="dark bg-background text-foreground py-20 px-4 md:px-8">
      <div className="container mx-auto max-w-7xl">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl font-serif uppercase">
              Selected Works
            </h2>
            <p className="text-muted-foreground max-w-2xl text-lg font-sans">
              Mastering the art of the final frame. Explore our latest cinematic
              post-production projects.
            </p>
          </div>

          <Button variant="outline" onClick={handleViewAll} className="hidden md:flex rounded-none border-primary text-primary hover:bg-primary hover:text-white font-sans uppercase tracking-widest">
            View All Work
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {displayedVideos.map((video, i) => <Link key={video.id} to="#" onClick={e => {
          e.preventDefault();
          setSelectedVideo(video);
          setIsModalOpen(true);
        }} className="group relative block overflow-hidden rounded-none bg-black shadow-none ring-0 transition-all duration-300 hover:ring-1 hover:ring-primary" data-index={i}>
              <AspectRatio ratio={16 / 9}>
                {i === 0 ? <div className="h-full w-full cursor-pointer">
                    <img src={video.image} alt={video.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" data-active-element="true" />
                  </div> : <img src={video.image} alt={video.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />}

                <div className="absolute inset-0 bg-black/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <div className="relative flex items-center justify-center">
                    <svg className="size-16 -rotate-90 drop-shadow-lg" viewBox="0 0 36 36">
                      <path className="text-white/10" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="1" />
                      <path className="text-primary" strokeDasharray={`${video.progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="square" />
                    </svg>
                    <Play className="absolute ml-1 size-6 fill-primary text-primary" />
                  </div>
                  <span className="absolute mt-24 font-sans text-[10px] uppercase tracking-[0.2em] text-white">
                    View Project
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 translate-y-full p-5 transition-transform duration-400 ease-out group-hover:translate-y-0">
                  <div className="flex flex-col gap-1">
                    <h3 className="font-sans text-sm font-bold tracking-widest text-white uppercase">
                      {video.title}
                    </h3>
                    <div className="flex items-center gap-2 text-[10px] font-medium text-gray-400 uppercase tracking-wider">
                      <span>{video.duration}</span>
                      <span className="h-px w-4 bg-primary" />
                      <span>{video.category}</span>
                    </div>
                  </div>
                </div>
              </AspectRatio>
            </Link>)}
        </div>

        {isModalOpen && selectedVideo && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 md:p-8">
            <div className="relative w-full max-w-5xl aspect-video bg-black shadow-2xl border border-white/5">
              <Button variant="ghost" size="icon" onClick={() => setIsModalOpen(false)} className="absolute -top-12 right-0 text-white hover:text-primary rounded-none transition-colors">
                <X className="size-8" />
                <span className="sr-only">Close</span>
              </Button>

              {isHost && selectedVideo.id === 1 && <Button variant="outline" className="absolute -top-12 left-0 rounded-none border-primary text-primary hover:bg-primary hover:text-white font-sans uppercase tracking-widest h-9 px-4">
                  Connect Video
                </Button>}

              <video src={selectedVideo.src} className="h-full w-full object-contain" controls autoPlay />
            </div>
          </div>}

        <div className="mt-12 flex justify-center">
          <Button size="lg" onClick={hasMore ? handleLoadMore : handleShowLess} className="min-w-[200px] gap-2 rounded-none bg-transparent border border-primary text-primary hover:bg-primary hover:text-white font-sans uppercase tracking-widest transition-colors duration-300">
            <Plus className="size-4" />
            {hasMore ? "Load More Content" : "Showing Less"}
          </Button>
        </div>
      </div>
    </section>;
}